import React from "react";
import '../../../sass/components/flexibleModules/homepage/_components.HomepageFancyGridModule.scss';
import { GatsbyImage, getImage } from "gatsby-plugin-image";

const HomepageFancyGridModule = ({ data, classOverride }) => {
    return (
        <div className={`cp-homepageFancyGridModule ${classOverride}`}>
            <div className="cp-homepageFancyGridModule__inner" style={{ maxWidth: `${data.maxWidth}px`, margin: "0 auto" }}>
                {data.homepageFancyGridModuleHeader &&
                    <>
                        <h2 data-sal="slide-up" data-sal-duration="800" data-sal-delay="300" data-sal-easing="ease">{data.homepageFancyGridModuleHeader}</h2>
                        <span data-sal="slide-up" data-sal-duration="800" data-sal-delay="300" data-sal-easing="ease" className="l__divider"></span>
                    </>
                }
                {data.homepageFancyGridModuleGridSections &&
                    <div className="cp-homepageFancyGridModule__grid l--flex">
                        <div className="cp-homepageFancyGridModule__grid-section">
                            {data.homepageFancyGridModuleGridSections.map((gridSection, index) => (
                                <React.Fragment key={index}>
                                    {index < 2 &&
                                        <div className="l--Grid" data-sal="slide-right" data-sal-duration="800" data-sal-delay="100" data-sal-easing="ease">
                                            <div className="l--Grid__image">
                                                {gridSection.image &&
                                                    <GatsbyImage image={getImage(gridSection.image.gatsbyImage)} alt={gridSection.image.altText} />
                                                }
                                            </div>
                                            <div className="l--Grid__content">
                                                {gridSection.header &&
                                                    <h3>{gridSection.header}</h3>
                                                }
                                                {gridSection.teaser &&
                                                    <div dangerouslySetInnerHTML={{ __html: gridSection.teaser }} />
                                                }
                                                {gridSection.button &&
                                                    <>
                                                        {gridSection.button.url.substr(-1) !== '/' ?
                                                            <a className="l-button l--blue" href={`${gridSection.button.url + '/'}`} target={gridSection.button.target} dangerouslySetInnerHTML={{__html: gridSection.button.title}} />
                                                            :
                                                            <a className="l-button l--blue" href={gridSection.button.url} target={gridSection.button.target} dangerouslySetInnerHTML={{__html: gridSection.button.title}} />
                                                        }
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    }
                                </React.Fragment>
                            ))}
                        </div>
                        <div className="cp-homepageFancyGridModule__grid-section">
                            {data.homepageFancyGridModuleGridSections.map((gridSection, index) => (
                                <React.Fragment key={index}>
                                    {index > 1 &&
                                        <div className="l--Grid" data-sal="slide-up" data-sal-duration="800" data-sal-delay="100" data-sal-easing="ease">
                                            <div className="l--Grid__image">
                                                {gridSection.image &&
                                                    <GatsbyImage image={getImage(gridSection.image.gatsbyImage)} alt={gridSection.image.altText} />
                                                }
                                            </div>
                                            <div className="l--Grid__content">
                                                {gridSection.header &&
                                                    <h3>{gridSection.header}</h3>
                                                }
                                                {gridSection.teaser &&
                                                    <div dangerouslySetInnerHTML={{ __html: gridSection.teaser }} />
                                                }
                                                {gridSection.button &&
                                                    <>
                                                        {gridSection.button.url.substr(-1) !== '/' ?
                                                            <a className="l-button l--blue" href={`${gridSection.button.url + '/'}`} target={gridSection.button.target} dangerouslySetInnerHTML={{__html: gridSection.button.title}} />
                                                            :
                                                            <a className="l-button l--blue" href={gridSection.button.url} target={gridSection.button.target} dangerouslySetInnerHTML={{__html: gridSection.button.title}} />
                                                        }
                                                    </>
                                                }
                                            </div>
                                        </div>
                                    }
                                </React.Fragment>
                            ))}
                        </div>
                    </div>
                }
            </div>
        </div>
    );
}

export default HomepageFancyGridModule;